import EditNewsContainer from "../containers/EditNewsContainer";

const EditNewsPage = () => {
  return (
    <EditNewsContainer />
  );
};

export default EditNewsPage;
